import React from "react";
import { useLanguage } from "../i18n/LanguageContext";

type PageBannerProps = {
  title: string;
  subtitle?: string;
};

const PageBanner: React.FC<PageBannerProps> = ({ title, subtitle }) => {
  const { dir } = useLanguage();
  const isRtl = dir === "rtl";

  return (
    <section className="overflow-hidden bg-second-color py-24 text-white sm:py-28 lg:py-32">
      <div
        className={`site-container flex flex-col gap-4 ${
          isRtl ? "items-end text-right" : "items-start text-left"
        }`}
      >
        <h1 className="hero-title max-w-4xl">
          {title}
        </h1>
        {subtitle ? (
          <p className="hero-subtitle max-w-2xl text-white/85">
            {subtitle}
          </p>
        ) : null}
      </div>
    </section>
  );
};

export default PageBanner;
